import { Grid, Cell } from 'baseui/layout-grid'
import CommonFallback from '@/shared/components/CommonFallback'
import ContractsFilters from './ContractsFilters/ContractsFilters'
import ContractsTable from './ContractsTable/ContractsTable'
import ContractsPagination from './ContractsPagination/ContractsPagination'
import useDashboardV2 from './useDashboardV2'
import GenericButtonGroup from './ContractsFilters/Filters/GenericButtonGroup'

const DashboardV2 = () => {
  const {
    isLoading,
    getContracts,
    filters,
    applicationType,
    usersList,
    providersList,
    formInitUrl,
    t,
    navigateToBusinessVertical,
  } = useDashboardV2()

  if (isLoading) {
    return <CommonFallback />
  }

  return (
    <Grid>
      <Cell span={12}>
        <Grid>
          <Cell span={12}>
            <GenericButtonGroup
              values={[
                t('subscriptionTable:link_to_energy_text'),
                t('subscriptionTable:link_to_telecom_text'),
                t('subscriptionTable:link_to_insurance_text'),
              ]}
              selected={[]}
              label=''
              onClick={navigateToBusinessVertical}
            />
          </Cell>
        </Grid>
      </Cell>
      <Cell span={12}>
        <ContractsFilters
          filters={filters}
          providersList={providersList}
          usersList={usersList}
          applicationType={applicationType}
        />
      </Cell>
      <Cell span={12}>
        <ContractsTable businessType={applicationType} getContracts={getContracts} formInitUrl={formInitUrl} />
        <ContractsPagination />
      </Cell>
    </Grid>
  )
}

export default DashboardV2
